import { ExcelGrid } from "@remotion-src/components/ExcelGrid";

const EXCEL_FILE_NAME = "CTO候補_2024-03-01_2024-03-22.xlsx";

export function Step4OperationsSection() {
  return (
    <section className="bg-white">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 items-center gap-12 px-6 py-24 lg:grid-cols-[minmax(0,420px)_minmax(0,1fr)]">
        {/* 左: テキスト */}
        <div>
          <span className="inline-flex items-center gap-1 rounded-md bg-brand-50 px-2.5 py-1 text-[11px] font-bold tracking-wider text-brand-700">
            STEP 4 · 送信業務管理
          </span>
          <h3 className="mt-5 text-[34px] font-bold leading-[1.2] tracking-tight md:text-[40px]">
            <span className="whitespace-nowrap">送信状況を記録して、</span>
            <br />
            <span className="whitespace-nowrap">作業内容をレポート可能</span>
          </h3>
          <p className="mt-5 text-[14px] leading-relaxed text-ink-600">
            候補者一覧から直接エクスポートを開始。
            <br />
            生成されたExcelをチームで共有できます。
          </p>
          <ul className="mt-6 space-y-3 text-[14px]">
            <li className="flex items-center gap-2.5">
              <span className="grid h-5 w-5 place-items-center rounded-full bg-brand-600 text-white">
                <span className="mi text-[14px]">check</span>
              </span>
              募集要項と期間を選んで一括エクスポート
            </li>
            <li className="flex items-center gap-2.5">
              <span className="grid h-5 w-5 place-items-center rounded-full bg-brand-600 text-white">
                <span className="mi text-[14px]">check</span>
              </span>
              進捗を表示しながらバックグラウンドで処理
            </li>
            <li className="flex items-center gap-2.5">
              <span className="grid h-5 w-5 place-items-center rounded-full bg-brand-600 text-white">
                <span className="mi text-[14px]">check</span>
              </span>
              完了したらExcelファイルをそのままダウンロード
            </li>
          </ul>
        </div>

        {/* 右: Excel プレビュー（静的） */}
        <div className="overflow-hidden rounded-2xl bg-white shadow-card ring-1 ring-ink-200/60">
          <div style={{ aspectRatio: "1 / 1" }}>
            <ExcelGrid fileName={EXCEL_FILE_NAME} />
          </div>
        </div>
      </div>
    </section>
  );
}
